/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Choice/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaChoice from 'DesignSystem/TysiaChoice/index'
import TysiaChoiceText from 'DesignSystem/TysiaChoice/TysiaChoiceText/index'



/** @type {import('Simple/types.js').View} */
export default function Choice({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CalendarSettings/Settings/Content/Content/PatientDefault/Choice"
  
}) {
let optionIdValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'id',
})
let optionItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'option_item',
path: 'isFirst',
})
let optionItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'option_item',
path: 'isLast',
})
let optionIdValueData1 = fromData.useDataValue({ viewPath,
context: 'option',
path: 'id',
})
let settingsPatientDefaultValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'patient_default',
})
let aggregateData = fromAggregate.equals(optionIdValueData1, settingsPatientDefaultValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let optionTextValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'text',
})
let optionIdValueData2 = fromData.useDataValue({ viewPath,
context: 'option',
path: 'id',
})
let settingsPatientDefaultValueData1 = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'patient_default',
})
let aggregateData1 = fromAggregate.equals(optionIdValueData2, settingsPatientDefaultValueData1)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaChoice
  viewPath={`${viewPath}/TysiaChoice`}
 marginTop={0}
 width={90}
 height={24}
 borderTopRightRadius={optionItemIsLastValueData ? dtSpaceXxs : "0px"}
 borderBottomRightRadius={optionItemIsLastValueData ? dtSpaceXxs : "0px"}
 borderTopLeftRadius={optionItemIsFirstValueData ? dtSpaceXxs : "0px"}
 borderBottomLeftRadius={optionItemIsFirstValueData ? dtSpaceXxs : "0px"}
 paddingBottom={dtSpaceXxs}
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
 paddingTop={dtSpaceXxs}
 backgroundColor={aggregateData ? dtColorsGreen700 : dtColorsWhite}
 borderColor={dtColorsNeutral300}
 borderWidth={1}
 alignItems="center"
 justifyContent="center"
 data={optionItemIsFirstValueData ? "option_item.isLast" : optionItemIsLastValueData ? "option.id" : "option.id"}
 id={optionIdValueData}
 onClick={onClick}
 data={optionItemIsFirstValueData ? "option_item.isLast" : optionItemIsLastValueData ? "option.id" : "option_item.isFirst"}
>
{childProps => (
<TysiaChoiceText
{...childProps}
  viewPath={`${viewPath}/TysiaChoiceText`}
 data="option.text"
 text={optionTextValueData}
 color={aggregateData1 ? dtColorsWhite : dtColorsNeutral900}
 data="option.id"
 data="settings.patient_default"
 aggregate="/Data/aggregate.js equals"
/>
)}
</TysiaChoice>
{children}
</React.Fragment>)
}